export default {"src":"/_next/static/media/factory-icon.11e16b19.svg","height":20,"width":20};